/**
 * User-facing error messages for provider validation
 */
export const VALIDATION_MESSAGES = Object.freeze({
  DUPLICATE_PROVIDER: 'Provider is already in roster',
  DUPLICATE_EMAIL:
    'This email is already associated with another provider in your roster',
  LAST4_REQUIRED: 'Last 4 characters required',
  LAST4_INVALID: 'Must be exactly 4 alphanumeric characters',
  LAST4_MISMATCH: 'Last 4 digits do not match our records',
  LAST4_VERIFICATION_FAILED: 'Verification failed. Please try again.',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid email',
  EMAIL_NOT_PROFESSIONAL: 'Please use a professional email address',
  EMAIL_TAKEN: 'This email address is already in use',
  EMAIL_VALIDATION_FAILED: 'Email validation failed. Please try again.',
  NPI_NOT_FOUND: 'No provider found with this NPI',
  NAME_NOT_FOUND: 'No provider found with this name',
  SEARCH_ERROR: 'Search failed. Please try again.',
});

/**
 * Error types for form validation.
 * These are used by React Hook Form to categorize validation errors.
 * Keep these simple - users see the message, not the type.
 */
export const ERROR_TYPES = Object.freeze({
  /** User input is invalid (wrong format, not professional, etc.) */
  INVALID_INPUT: 'invalidInput',

  /** Search found no results (provider/email doesn't exist) */
  NOT_FOUND: 'notFound',

  /** Duplicate detected (provider or email already in roster) */
  ALREADY_EXISTS: 'alreadyExists',

  /** System error (API failed, network error, etc.) */
  VALIDATION_ERROR: 'validationError',
});
